import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import '../styles/cinematic.css';
import ParallaxBackground from '../components/ParallaxBackground';
import Footer from '../components/Footer';

// Assets
import culturalClusterLogo from '../assets/team/cultural-cluster.png';
import iimvLogo from '../assets/team/iimv-logo.png';
import artquakeLogo from '../assets/team/artquake.png';
import spotlightLogo from '../assets/team/spotlight.png';
import vatsalyaLogo from '../assets/team/vatsalya.png';

const Team = () => {
    const [location, setLocation] = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{
            width: '100vw',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            overflowX: 'hidden',
            overflowY: 'auto',
            position: 'relative'
        }}>
            {/* 0. GLOBAL BACKGROUND */}
            <ParallaxBackground />

            {/* CONTENT LAYER */}
            <div style={{
                position: 'relative',
                zIndex: 10,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '40px 20px',
                paddingBottom: '100px'
            }}>

                {/* 1. MAIN LOGOS (Cultural Cluster & IIMV) - Smaller */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'stretch', // Match height
                    gap: '40px',
                    flexWrap: 'wrap',
                    marginBottom: '60px',
                    marginTop: '100px'
                }}>
                    {/* IIMV - Smaller */}
                    <div className="glass-card" style={{
                        padding: '20px',
                        background: 'rgba(40, 30, 0, 0.4)',
                        border: '2px solid #FFD700',
                        borderRadius: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        boxShadow: '0 0 30px rgba(255, 215, 0, 0.3), inset 0 0 20px rgba(255, 215, 0, 0.1)',
                        backdropFilter: 'blur(10px)'
                    }}>
                        <img
                            src={iimvLogo}
                            alt="IIM Visakhapatnam"
                            style={{
                                width: '180px', // Reduced from 280px
                                height: 'auto',
                                objectFit: 'contain',
                                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.5))'
                            }}
                        />
                        <h2 style={{
                            marginTop: '15px',
                            fontFamily: 'Orbitron',
                            color: '#FFD700',
                            fontSize: '1.1rem',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            textShadow: '0 0 10px rgba(255, 215, 0, 0.8)'
                        }}>IIM VISAKHAPATNAM</h2>
                    </div>
                    {/* Cultural Cluster - Smaller */}
                    <div className="glass-card" style={{
                        padding: '20px',
                        background: 'rgba(0, 20, 40, 0.4)',
                        border: '2px solid #00F5FF',
                        borderRadius: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        boxShadow: '0 0 30px rgba(0, 245, 255, 0.3), inset 0 0 20px rgba(0, 245, 255, 0.1)',
                        backdropFilter: 'blur(10px)'
                    }}>
                        <img
                            src={culturalClusterLogo}
                            alt="Cultural Cluster"
                            style={{
                                width: '180px', // Reduced from 280px
                                height: 'auto',
                                objectFit: 'contain',
                                filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.5))'
                            }}
                        />
                        <h2 style={{
                            marginTop: '15px',
                            fontFamily: 'Orbitron',
                            color: '#00F5FF',
                            fontSize: '1.1rem',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            textShadow: '0 0 10px rgba(0, 245, 255, 0.8)'
                        }}>CULTURAL CLUSTER</h2>
                    </div>
                </div>

                {/* 2. CLUB LOGOS (Artquake, Spotlight, Vatsalya) - Larger */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: '50px',
                    flexWrap: 'wrap',
                    width: '100%',
                    maxWidth: '1200px'
                }}>
                    {/* Artquake */}
                    <div className="holo-card" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '260px', // Increased from 220px
                        textAlign: 'center'
                    }}>
                        <div style={{
                            width: '220px', // Increased from 180px
                            height: '220px',
                            borderRadius: '50%',
                            background: 'rgba(255, 0, 149, 0.1)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '20px',
                            border: '3px solid #FF0095',
                            boxShadow: '0 0 25px rgba(255, 0, 149, 0.6), inset 0 0 15px rgba(255, 0, 149, 0.2)',
                            padding: '15px',
                            backdropFilter: 'blur(5px)'
                        }}>
                            <img
                                src={artquakeLogo}
                                alt="Artquake"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    filter: 'drop-shadow(0 0 5px rgba(255, 255, 255, 0.8))'
                                }}
                            />
                        </div>
                        <h3 style={{
                            fontFamily: 'Orbitron',
                            color: '#FF0095',
                            fontSize: '1.4rem',
                            marginTop: '5px',
                            textShadow: '0 0 10px rgba(255, 0, 149, 0.8)'
                        }}>ARTQUAKE</h3>
                    </div>

                    {/* Spotlight */}
                    <div className="holo-card" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '260px', // Increased
                        textAlign: 'center'
                    }}>
                        <div style={{
                            width: '220px', // Increased
                            height: '220px',
                            borderRadius: '50%',
                            background: 'rgba(0, 245, 255, 0.1)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '20px',
                            border: '3px solid #00F5FF',
                            boxShadow: '0 0 25px rgba(0, 245, 255, 0.6), inset 0 0 15px rgba(0, 245, 255, 0.2)',
                            padding: '15px',
                            backdropFilter: 'blur(5px)'
                        }}>
                            <img
                                src={spotlightLogo}
                                alt="Spotlight"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    filter: 'drop-shadow(0 0 5px rgba(255, 255, 255, 0.8))'
                                }}
                            />
                        </div>
                        <h3 style={{
                            fontFamily: 'Orbitron',
                            color: '#00F5FF',
                            fontSize: '1.4rem',
                            marginTop: '5px',
                            textShadow: '0 0 10px rgba(0, 245, 255, 0.8)'
                        }}>SPOTLIGHT</h3>
                    </div>

                    {/* Vatsalya */}
                    <div className="holo-card" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '260px', // Increased
                        textAlign: 'center'
                    }}>
                        <div style={{
                            width: '220px', // Increased
                            height: '220px',
                            borderRadius: '50%',
                            background: 'rgba(0, 255, 0, 0.1)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '20px',
                            border: '3px solid #00FF00',
                            boxShadow: '0 0 25px rgba(0, 255, 0, 0.6), inset 0 0 15px rgba(0, 255, 0, 0.2)',
                            padding: '15px',
                            backdropFilter: 'blur(5px)'
                        }}>
                            <img
                                src={vatsalyaLogo}
                                alt="Vatsalya"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    filter: 'drop-shadow(0 0 5px rgba(255, 255, 255, 0.8))'
                                }}
                            />
                        </div>
                        <h3 style={{
                            fontFamily: 'Orbitron',
                            color: '#00FF00',
                            fontSize: '1.4rem',
                            marginTop: '5px',
                            textShadow: '0 0 10px rgba(0, 255, 0, 0.8)'
                        }}>VATSALYA</h3>
                    </div>
                </div>

            </div>


            {/* Mobile Styles via Style Tag */}
            <style>{`
                @media (max-width: 768px) {
                    .glass-card {
                        width: 100% !important;
                        padding: 20px !important;
                        margin-bottom: 20px !important;
                    }
                    .glass-card img {
                        width: 100% !important;
                        max-width: 200px !important;
                    }
                    .glass-card h2 {
                        font-size: 1.1rem !important;
                    }
                    .holo-card {
                        width: 160px !important; /* Adjusted for mobile */
                    }
                    .holo-card > div {
                        width: 140px !important;
                        height: 140px !important;
                    }
                    .holo-card h3 {
                        font-size: 1rem !important;
                    }
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Team;
